"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _coreSanitize = _interopRequireDefault(require("../core-sanitize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */

/**
* SDK Core URL
*
* URL parsing with defaulting foor relative URLs
*
* @module core-url
*
* @author Nathan Freeling
* @copyright 2018 Wells Fargo, All rights reserved.
*/

/**
 * Parses a URL and provides default values for relative URLs
 *
 * @param {String} url The absolute or relative URL to be parsed
 * @return {object} The URL parsed into its component parts
 */
var parseUrl = function parseUrl(url) {
  var cleanUrl = _coreSanitize["default"].sanitizeAll(url) || '';
  var ret = {
    'protocol': '',
    'hostname': '',
    'port': '',
    'pathname': '',
    'parameters': '',
    'hash': ''
  };
  var match = cleanUrl.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/);
  ret.protocol = match[1] || window.location.protocol;

  // is this a relative URL? Check the hostname.
  if (!match[4]) {
    // this is a relative URL, use current host info
    ret.hostname = window.location.hostname;
    ret.port = window.location.port;
  } else {
    // this is an absolute URL
    ret.hostname = match[4];
    var portMatch = ret.hostname.match(/:(\d{1,5})/);
    if (portMatch) {
      // set the port
      ret.port = portMatch[1];

      // remove the port from the hostname
      ret.hostname = ret.hostname.replace(':' + ret.port, '');
    }
  }
  ret.pathname = match[5];
  if (ret.pathname && ret.pathname.charAt(0) !== '/') {
    ret.pathname = '/' + ret.pathname;
  }
  ret.parameters = match[7] || '';
  ret.hash = match[9] || '';
  ret.fullURL = ret.protocol + '//' + ret.hostname + (ret.port ? ':' + ret.port : '') + ret.pathname + (ret.parameters ? '?' + ret.parameters : '') + (ret.hash ? '#' + ret.hash : '');
  return ret;
};
var _default = exports["default"] = parseUrl;
//# sourceMappingURL=index.js.map